import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-receipt-conversion-card',
  templateUrl: './receipt-conversion-card.component.html',
  styleUrls: ['./receipt-conversion-card.component.scss'],
})
export class ReceiptConversionCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public convert: number = 0;
  public lastConvert: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getConvert()
      .then((value) => {
        this.convert = value.currentValue;
        this.lastConvert = value.valueLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
